// Дополнительные значки функции (lucide, офлайн): добавляются в общий словарь ICONS по имени - аддитивно,
// существующие имена не переопределяются.
import {
  RotateCw, RotateCcw, Crop, Maximize2, ImageUp, ImagePlus, Images, Globe, GripVertical, ArrowDownAZ, ArrowDownZA,
  ListOrdered, WrapText, FileCode2, TableCellsMerge, TableCellsSplit, Ruler, FlipHorizontal2, WandSparkles,
  BetweenHorizontalStart, BetweenHorizontalEnd, BetweenVerticalStart, BetweenVerticalEnd, Sheet, Columns2, PanelTop,
  Replace, Accessibility, FileSpreadsheet, Minus, Rows2, Equal, ScanText, ChevronsLeftRight,
} from 'lucide-react';
import { ICONS } from '../../ui/icons';

const EXTRA = {
  'tfc-rotate-cw': RotateCw, 'tfc-rotate-ccw': RotateCcw, 'tfc-crop': Crop, 'tfc-fit': Maximize2, 'tfc-replace': ImageUp,
  'tfc-image-plus': ImagePlus, 'tfc-gallery': Images, 'tfc-url': Globe, 'tfc-grip': GripVertical, 'tfc-sort-az': ArrowDownAZ,
  'tfc-sort-za': ArrowDownZA, 'tfc-line-numbers': ListOrdered, 'tfc-wrap': WrapText, 'tfc-code-file': FileCode2,
  'tfc-merge': TableCellsMerge, 'tfc-split': TableCellsSplit, 'tfc-ruler': Ruler, 'tfc-flip': FlipHorizontal2,
  'tfc-magic': WandSparkles, 'tfc-row-above': BetweenHorizontalStart, 'tfc-row-below': BetweenHorizontalEnd,
  'tfc-col-left': BetweenVerticalStart, 'tfc-col-right': BetweenVerticalEnd, 'tfc-sheet': Sheet, 'tfc-cols-equal': Columns2,
  'tfc-header': PanelTop, 'tfc-swap': Replace, 'tfc-alt': Accessibility, 'tfc-csv': FileSpreadsheet, 'tfc-dash': Minus,
  'tfc-rows': Rows2, 'tfc-equal': Equal, 'tfc-text-to-table': ScanText, 'tfc-width': ChevronsLeftRight,
};

export function registerIcons() {
  for (const [k, v] of Object.entries(EXTRA)) if (!(k in ICONS)) (ICONS as Record<string, any>)[k] = v;
}
